import React from 'react';
import { UserProfile } from '@clerk/clerk-react';
import './Settings.css';

const Settings = () => {
  return (
    <div className="settings-container">
      <div className="settings-header">
        <h1>Settings</h1>
        <p>Manage your account settings and preferences.</p>
      </div>

      <div className="settings-card" style={{ padding: 16 }}>
        <UserProfile
          routing="path"
          path="/dashboard/settings"
          appearance={{
            elements: {
              card: {
                backgroundColor: 'rgba(18, 30, 52, 0.98)',
                border: '1px solid rgba(255,255,255,0.10)'
              }
            }
          }}
        />
      </div>
    </div>
  );
};

export default Settings;